import type {
  CoachingSession,
  CoachingSessionStatus,
} from '@efdigital/ll-addon-data';
import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import { query } from '@warp-drive/utilities/json-api';

import {
  include,
  jsonApiOptions,
  page,
  type PageOptions,
} from '../../json-api.ts';

const MAX_SESSIONS_PER_COACHEE = 100;
const MAX_SESSIONS_PER_COACH = 100;

export function queryCoachingSessionsByCoachingPlan(
  coachingPlanId: string,
  status?: CoachingSessionStatus[]
) {
  return query<CoachingSession>(
    DataTypeCoaching.CoachingSession,
    {
      ...(status?.length ? { 'filter[status][$in][]': status } : {}),
      'filter[coachingPlan.id]': coachingPlanId,
      ...page({ offset: 0, limit: MAX_SESSIONS_PER_COACHEE }),
      'sort[]': 'startTime',
    },
    jsonApiOptions
  );
}

export function queryCoachingSessionsByCoach(
  coachUserId: string,
  status?: CoachingSessionStatus[],
  pagingOptions?: PageOptions
) {
  return query<CoachingSession>(
    DataTypeCoaching.CoachingSession,
    {
      ...(status?.length ? { 'filter[status][$in][]': status } : {}),
      'filter[coachUserId]': coachUserId,
      ...page(pagingOptions ?? { offset: 0, limit: MAX_SESSIONS_PER_COACH }),
      ...include([
        'coachingPartnership',
        'coachingPlan',
        'coachingPlan.coaching',
        'coachingPlan.coaching.coachingConfig',
      ]),
      sort: 'startTime',
    },
    jsonApiOptions
  );
}

export function queryCoachingSessionsByCoachingPlanAndCoach(
  coachingPlanId: string,
  coachUserId: string
) {
  return query<CoachingSession>(
    DataTypeCoaching.CoachingSession,
    {
      'filter[coachingPlan.id]': coachingPlanId,
      'filter[coachUserId]': coachUserId,
      ...page({ offset: 0, limit: MAX_SESSIONS_PER_COACHEE }),
    },
    jsonApiOptions
  );
}
